import Vue from 'vue'
import App from './App.vue'
import store from './store'
import vuetify from './plugins/vuetify';
import VueLazyLoad from 'vue-lazyload';
Vue.use(VueLazyLoad);
Vue.use(vuetify, {
  iconfont: 'mdi'
})

Vue.config.productionTip = false;
import sanitizeHTML from 'sanitize-html';
Vue.prototype.$sanitize = sanitizeHTML;

new Vue({
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
